import { Transfer, Input } from "antd";

import { useState } from "react";

// import "../FileTransfer/FileTransfer.css";
import "../../GlobalCss/SPF/ExpensesMasterfile.css";
const ExpensesFileTransfer = (props) => {
  const [searchQuery, setSearchQuery] = useState("");

  //Extracting data from props
  const {
    clientsList,
    targetKeys,
    setTargetKeys,
    selectedKeys,
    setSelectedKeys,
    Vms,
    frequency,
    fromDate, 
    toDate
  } = props;

  const ModifiedCLientsObject = clientsList.map((eachClient) => ({
    key: eachClient,
    title: eachClient,
  }));

  const onChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys);
  };

  const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };

  const onScroll = (direction, e) => {
    console.log("direction:", direction);

    console.log("target:", e.target);
  };

  const filteredClients = ModifiedCLientsObject.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <>
      <div className="custom-transfer search-transfer">
        <div>
          <Input
            className="search-box"
            id="Name"
            name="Subject"
            placeholder="Search"
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className="error-note">
          {Vms.length === 0 ? (
            <p>Note: Please select VMS</p>
          
          ) :null}
        </div>
        <div style={{marginTop:"1.75%"}}>
          <Transfer
            className="transfer-clients"
            dataSource={filteredClients}
            targetKeys={targetKeys}
            setTargetKeys={setTargetKeys}
            selectedKeys={selectedKeys}
            setSelectedKeys={setSelectedKeys}
            onChange={onChange}
            onSelectChange={onSelectChange}
            onScroll={onScroll}
            render={(item) => item.title}
          />
        </div>
      </div>
    </>
  );
};

export default ExpensesFileTransfer;
